/* istanbul ignore file */
import { Box, Typography } from '@mui/material';
import { NameInputLayoutType } from 'framework/form';
import FormRow from '../FormRow/FormRow';

const NameInputLayout: NameInputLayoutType = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactElement[];
}) => {
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      {label && (
        <Typography variant="subtitle1" color="textPrimary" component="label">
          {label}:
        </Typography>
      )}

      <FormRow>{children}</FormRow>
    </Box>
  );
};

export default NameInputLayout;
